import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { waterOrigins } from '../DataSets';

const WaterOrigin = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="waterOrigin"
      name="waterOrigin"
      items={waterOrigins}
      label="Water Origin"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select water origin"
    />
  );
};

export default WaterOrigin;
